import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b8bcab8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "font-bold text-base" }
const _hoisted_2 = {
  key: 0,
  class: "absolute flex justify-center items-center inset-0 bg-green-300 bg-opacity-20 m-2"
}
const _hoisted_3 = { class: "flex justify-center items-center text-primary" }
const _hoisted_4 = {
  key: 1,
  class: "absolute flex justify-center items-center inset-0 bg-green-300 bg-opacity-20 m-2"
}
const _hoisted_5 = { class: "flex justify-center items-center text-primary" }
const _hoisted_6 = {
  key: 0,
  class: ""
}
const _hoisted_7 = {
  key: 1,
  class: ""
}
const _hoisted_8 = {
  key: 0,
  class: ""
}
const _hoisted_9 = {
  key: 1,
  class: ""
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "btn-action" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("  Save ")
const _hoisted_16 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_View = _resolveComponent("View")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Variant = _resolveComponent("Variant")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.state.isContentShown,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.isContentShown) = $event)),
      width: _ctx.state.isSubmited === _ctx.ACTION.DETAIL ? '70%' : '60%',
      top: "2vh",
      onClose: _ctx.cancel
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.state.formTitle), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "formAddProduct",
          model: _ctx.state.product,
          "label-width": "100px",
          width: "100%",
          rules: _ctx.formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Handle",
              prop: "handle",
              style: {"width":"60%"},
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.state.product.handle,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.product.handle) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Name",
              prop: "title",
              style: {"width":"60%"},
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.state.product.title,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.product.title) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Catalog",
              prop: "catalogId",
              style: {"width":"45%"},
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.state.product.catalogId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.product.catalogId) = $event)),
                  placeholder: "Select Catalog",
                  style: {"width":"100%"},
                  filterable: "",
                  "default-first-option": "",
                  "reserve-keyword": false,
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChangeCatalog($event))),
                  disabled: _ctx.state.isSubmited == _ctx.ACTION.DETAIL,
                  "remote-method": _ctx.getCatalog
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.catalogs, (catalog) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: catalog._id,
                        label: catalog.name,
                        value: catalog._id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled", "remote-method"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Shopify ID",
              prop: "shopifyId",
              style: {"width":"60%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.state.product.shopifyId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.product.shopifyId) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Amazon ID",
              prop: "amazonId",
              style: {"width":"60%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.state.product.amazonId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.product.amazonId) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "Preview",
                  prop: "artwork1",
                  style: {"width":"30%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, {
                      src: _ctx.imageUrl(_ctx.state.product.artwork1, true),
                      lazy: ""
                    }, null, 8, ["src"]),
                    (0 === _ctx.hoverIndex)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_el_button, {
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.view(_ctx.state.product.artwork1))),
                              size: "small",
                              circle: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_View)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.delImg(0))),
                              type: "danger",
                              size: "small",
                              circle: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Delete)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_image, {
                      src: _ctx.imageUrl(_ctx.state.product.artwork2, true),
                      lazy: ""
                    }, null, 8, ["src"]),
                    (1 === _ctx.hoverIndex)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_el_button, {
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.view(_ctx.state.product.artwork2))),
                              size: "small",
                              circle: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_View)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.delImg(1))),
                              type: "danger",
                              size: "small",
                              circle: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Delete)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Preview",
                  prop: "artwork2",
                  style: {"width":"30%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, {
                      shadow: "never",
                      class: "flex justify-center items-center h-full p-2 border-dashed border"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "flex justify-center items-center",
                          type: "text"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, {
                              class: "el-icon--left",
                              size: 16
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Plus)
                              ]),
                              _: 1
                            }),
                            (!_ctx.content)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                              : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.content), 1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  class: "border-dashed border cursor-pointer",
                  onClick: _ctx.upload
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, {
                      shadow: "never",
                      class: "flex justify-center items-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "flex justify-center items-center",
                          type: "text"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, {
                              class: "el-icon--left",
                              size: 16
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Plus)
                              ]),
                              _: 1
                            }),
                            (!_ctx.content)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                              : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.content), 1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createVNode(_component_Variant, {
          isLoading: _ctx.state.isLoading
        }, null, 8, ["isLoading"]),
        (_ctx.state.isSubmited !== _ctx.ACTION.DETAIL)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
                  default: _withCtx(() => [
                    _hoisted_12,
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, { onClick: _ctx.onSubmit }, {
                  default: _withCtx(() => [
                    _hoisted_14,
                    _hoisted_15
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "width", "onClose"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dialog) = $event)),
      title: "Preview image",
      width: "60%",
      center: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: _ctx.imageUrl(_ctx.imgView)
        }, null, 8, _hoisted_16)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}